var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "app-main-content",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(170,170,170,0.5)"
      }
    },
    [
      _c("div", { staticClass: "operations" }, [
        _c("div", { staticClass: "triggers" }, [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "4px" } },
            [
              _c(
                "el-radio-group",
                {
                  staticStyle: { "margin-left": "5px" },
                  on: { change: _vm.noChangeHandler },
                  model: {
                    value: _vm.picCategory,
                    callback: function($$v) {
                      _vm.picCategory = $$v
                    },
                    expression: "picCategory"
                  }
                },
                [
                  _c(
                    "el-radio",
                    {
                      staticStyle: { "margin-right": "5px" },
                      attrs: { label: _vm.DocumentConstants.WAREHOUSE_PIC }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BangPic")))]
                  ),
                  _c(
                    "el-radio",
                    { attrs: { label: _vm.DocumentConstants.LOADING_PIC } },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.PrintingPlatePhotos")))]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "inline-block",
                    width: "70px",
                    "text-align": "right",
                    color: "#666666"
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.picCategory === _vm.DocumentConstants.WAREHOUSE_PIC
                        ? _vm.$t("SeaExport.ReceiptNo")
                        : _vm.$t("Billing.WayBillNumber")
                    )
                  )
                ]
              ),
              _c("el-input", {
                staticStyle: { width: "150px", "margin-left": "5px" },
                on: { change: _vm.noChangeHandler },
                model: {
                  value: _vm.no,
                  callback: function($$v) {
                    _vm.no = $$v
                  },
                  expression: "no"
                }
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.browseClickHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.SelectFile")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.picGrid.deleteHandler()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DeleteSelected")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.startUploadHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_StartUploading")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.search_clickHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Query")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.batchDownBtnClickHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BatchDownload")))]
              )
            ],
            1
          )
        ])
      ]),
      _c("warehouse-pic-grid", {
        ref: "picGrid",
        staticStyle: { "flex-grow": "1" },
        attrs: {
          model: _vm.model || { business_Document: "" },
          category: _vm.picCategory,
          "show-buttons": false,
          "enable-delete-old-pic": false
        },
        on: { uploadDone: _vm.uploadDoneHandler }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }